// extracted by mini-css-extract-plugin
module.exports = {"ChevronLogo":"ChevronLogo_ChevronLogo__iAvaa","moveInLeft":"ChevronLogo_moveInLeft__23FHI"};